<template>
    
    <div class="content">
        
        
        <el-dialog
        :title="btnName"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose" center>
        
        <div style="width: 50%;margin-left: 100px;">

            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email"></el-input>
                
            </el-form-item>
            <span v-if="pageType == 0">
                <el-form-item label="密码" prop="password">
                 <el-input type="password" v-model="form.password"></el-input>
                </el-form-item>
            </span>
            <!--<el-form-item label="验证码" prop="code">
                <el-input v-model="form.code"></el-input>
                <el-button v-bind:class="{grey:isGrey,blue:!isGrey}" 
                        v-bind:disabled="dis" type="primary" 
                        @click="getCode('form')" style="width: 120px;">
                    <span v-if="show">发送验证码</span>
                    <span v-else>重新发送({{count}}s)</span>
                </el-button>
            </el-form-item>-->
        </el-form>

        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button @click="register">注册</el-button>
            <el-button type="primary" v-if="pageType == 0" @click="onSubmit('form')">登录</el-button>
        </span>
        </el-dialog>
    </div>
    



</template>
  
  <script>
    import {Message} from 'element-ui';
    
    export default {
      data() {
       
        return {
            dialogVisible: false,
            btnName:'登录',
            pageType:0, //默认0登录  1注册
            form: {
                email: '',
                code: '',
                password: '',
            },
            rules: {
                email: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
            },
            dis: false,
            show: true,
            isGrey: false, //按钮样式
            timer: null, //设置计时器,
            count: ""
        };
      },
      methods: {
        register(){
            this.dialogVisible = false;
            this.goRegisterPage();
        },
        onSubmit(formName) {

            this.$refs[formName].validate((valid) => {
            if (valid) {
                let self = this;
      
                self.postRequest('/user/login',this.form).then(resp =>{
                    Message.success({message: resp.msg})
                    this.dialogVisible=false;
                    location.reload();
                   // this.$router.push({path:"/txt"})
                })  

            } else {
                return false;
            }
            });
        },
        handleClose(done) {
         this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      getCode(formName) {
            console.log("formName:"+JSON.stringify(this.form));
            var validateFieldList = [];
            //var bbbb = this.$refs[formName].validateField("email");
            //console.log("bbb:"+bbbb)
            // 校验方法
            this.$refs[formName].validateField(['email'], valid => {
                if (!valid) {
                    // 校验通过后，将valid追加入数组
                    validateFieldList.push(valid)
                }

                // 校验数组长度与表单项相等，并且数组的每一项值都为空（‘’）
                if (validateFieldList.length == 1 && validateFieldList.every(item => item === '')) {
                    //校验通过的业务逻辑
                    let TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.isGrey = true;
                        this.show = false;
                        this.dis = true;
                        let self = this;
                        self.postRequest('/user/sendCode',this.form).then(resp =>{
                            
                            Message.success({message: resp.msg})
                            this.$router.push({path:"/my",params: {"type": 1}})
                        })
                        this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) { 
                            this.count--;
                        } else {
                            this.dis = false;
                            this.isGrey = false;
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                        }, 1000);
                        
                    }
                }

                // 校验不通过逻辑
                return  
            })

        }
       
      }
      
    }
  </script>
  <style>
.grey{
    background-color: #EDEEF1;
    border-color: #EDEEF1;
    color:#666;
    width: 30%;
  }
  .blue{
    background-color: #64A0DD;
    border-color: #64A0DD;
  }
</style>